import { Component, Injectable, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { Response } from "@angular/http";
import {  Router, NavigationEnd } from "@angular/router";

import { AdministrationService } from "../../../../../app/services/administration.service";
import { AlertService } from "../../../../../app/utils/alert.service";
import { DataPackUserManagerModel } from "../../../../../app/models/data.manager.model";
import { DataPackGroup } from "../../../../../app/models/dataPackGroup.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BindComponentService } from "../../../../../app/utils/bind.component.service";

import * as _ from "lodash";
import { DataPackLine } from "../../../../models/dataPackLine.model";
import { VoiceConsumeService } from "../../../../services/voice.consume.service";
import { BlockGroupService } from "../../../../services/block.group.service";
import { LoadingComponent } from "../../modalLoading/content.component";
import { ConsumeService } from "../../../../services/consume.service";
import { NgbPaginationConfig } from "@ng-bootstrap/ng-bootstrap";
import { PaginatedResult } from "../../../../models/paginatedResult.model";
import { VivoSyncService } from "app/services/vivo.sync.service";
import { ConfigureSyncModalComponent } from "../../vivosync/configure/content.component";

@Component({
  selector: "editAdministrator",
  templateUrl: "./content.modal.template.html"
})
/**
 * @version $Id$
 */
@Injectable()
export class Mobilesearch {

  @Input() count: any;
  @Input() typeValue: any;
  @Input() isVoiceConsumption: boolean;
  @Input() paginationSearch: any;
  @Input() hasOverBalanceMonetaryVoice: boolean;
  @Input() hasHibridService: boolean;

  private static readonly GROUPS_FETCH_SIZE: number = 20; //50
  private static readonly LINES_FETCH_SIZE: number = 20; //50


  public pageSize: number = Mobilesearch.LINES_FETCH_SIZE;
  public groups: Array<DataPackGroup> = new Array<DataPackGroup>();
  public listModel: Array<DataPackLine> = new Array<DataPackLine>();
  public isDisabled: boolean = true;
  public page: any;
  public startRow: number = 1;
  public pageBegin: number = this.startRow;
  public pageEnd: number = this.pageSize;



  public redirect(andress:string){
    this.router.navigate([andress], { queryParams: {filter:false} });
  }

  constructor(
    private bindComponent: BindComponentService,
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private adminService: AdministrationService,
    private alertService: AlertService,
    private voiceConsumeService: VoiceConsumeService,
    private blockService: BlockGroupService,
    private vivoSyncService: VivoSyncService,
    private consumeService: ConsumeService,
    private paginationConfig: NgbPaginationConfig,
    private router: Router
  ) {}

  ngOnInit() {
    this.page = 0;
  }

  private maskMsisdn(msisdn: string): string {
    if (_.isNil(msisdn)) {
      return "";
    }
    if (msisdn.length == 12) {
      return "("
        .concat(msisdn.substr(0, 3))
        .concat(") ")
        .concat(msisdn.substring(3, msisdn.length - 4))
        .concat("-")
        .concat(msisdn.substr(-4, 4));
    } else if (msisdn.length == 11) {
      return "("
        .concat(msisdn.substr(0, 2))
        .concat(") ")
        .concat(msisdn.substring(2, msisdn.length - 4))
        .concat("-")
        .concat(msisdn.substr(-4, 4));
    }
    return msisdn;
  }
  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: "static",
      keyboard: false
    });
  }


  public searchGroup(line: DataPackLine, is5GPortifolio: number) {
    let cleanUrl = this.router.url.split("?")[0];
    this.openModalLoading();
    let group: DataPackGroup = new DataPackGroup();
    let listLines: Array<DataPackLine> = new Array<DataPackLine>();
    this.groups = new Array<DataPackGroup>();
    group.id = Number(line.groupId);
    group.name = line.groupName;
    listLines.push(line);
    group.isErrorGroup = false;
    group.is5GPortifolio = is5GPortifolio;
    if (group.is5GPortifolio == 1){
      group.technology = "5G";
    }else{
      group.technology = "4G";
    }
    group.lines = listLines;
    //console.log("is5GPortifolio=>",is5GPortifolio);
    //console.log("technology=>",group.technology);
    if (this.isVoiceConsumption && is5GPortifolio === 0) {
      this.loadGroupFilterVoice(group, cleanUrl);
    } else {
      this.loadGroupFilterData(group, cleanUrl);
    }
  }

  public loadGroupFilterVoice(group: DataPackGroup, cleanUrl: string) {
    let currentService = null;
    let currentFilterBind = null;

    if (cleanUrl === "/Portal/data/vivosync") {
      currentService = this.vivoSyncService;
      currentFilterBind = BindComponentService.FILTER_SYNC;
    }else if(cleanUrl === "/Portal/data/block") {
      currentService = this.blockService;
      currentFilterBind = BindComponentService.FILTER_BLOCK;
    } else {
      currentService = this.voiceConsumeService;
      currentFilterBind = BindComponentService.FILTER_CONSUMPTION;
    }

    currentService
      .loadGroupFilterVoice(group, 1, Mobilesearch.GROUPS_FETCH_SIZE,this.hasOverBalanceMonetaryVoice,this.hasHibridService)
      .subscribe(
        data => {
          this.pushGroups(data,currentFilterBind);
        },
        err => {
         this.resultError(err);
        }
      );
  }

  public resultError(err:any){
    this.alertService.error(err.result, err);
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
    this.close();
  }

  public pushGroups(data:any,currentFilterBind:any){
    this.groups.push(data);
    this.bindComponent.set(currentFilterBind,this.groups);
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
    this.closeSearch();
  }

  public loadGroupFilterData(group: DataPackGroup, cleanUrl) {
    let currentService = null;
    let currentFilterBind = null;

    if(cleanUrl === "/Portal/data/block") {
      currentService = this.blockService;
      currentFilterBind = BindComponentService.FILTER_BLOCK;
    } else if(cleanUrl === "/Portal/data/vivosync") {
      currentService = this.vivoSyncService;
      currentFilterBind = BindComponentService.FILTER_SYNC;
    } else {
      currentService = this.consumeService;
      currentFilterBind = BindComponentService.FILTER_CONSUMPTION;
    }
    currentService
      .loadGroupFilterData(group, this.startRow, this.pageSize)
      .subscribe(
        data => {
          if(data['id'] != null){
            this.pushGroups(data,currentFilterBind);
          }else{
            this.alertService.warn('A linha selecionada não possui o serviço de dados.');
            this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
            this.closeSearch();
          }

        },
        error => {
          this.alertService.error(error.result, error);
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
          this.close();
        }
      );
  }

  loadPage(pag: number) {
    this.pageControl(pag);
    this.loadingLines();
  }


  public pageControl(pag: number) {
    this.pageBegin = pag;
  }



  public loadingLines(){
    this.openModalLoading();
    this.voiceConsumeService.searchLines(this.pageBegin,this.pageEnd,this.typeValue)
      .subscribe(
        data => {
          this.listModel = data['filterLines'];
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        },
        err => {
          this.resultError(err);
        }
      );
  }

  private close() {
    this.activeModal.dismiss();
    this.bindComponent.set(BindComponentService.LOADING_VOICE_CONSUMPTION,true);
  }

  private closeSearch() {
    this.activeModal.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/header/mobilesearch/content.component.ts